const VALID_URL_PROTOCOLS = ['http:', 'https:'];
const IP_V4_REGEX = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/;
const IP_V6_REGEX = /^(([0-9a-fA-F]{0,4}:){1,7}[0-9a-fA-F]{0,4})$/;

export function isPhoneNumberValid(value: string, data: {format?: string}): boolean {
    if (!data?.format || !value) {
        return false;
    }

    const expectedLength = (data.format.match(/\./g) || []).length;
    const actualLength = value.replace(/\D/g, '').length;
    return actualLength === expectedLength;
}

export function isEmailValid(email: string): boolean {
    return email && Boolean(email.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i));
}

export function isValidIpV4(ip: string): boolean {
    return ip && Boolean(ip.match(IP_V4_REGEX));
}

export function isValidIpV6(ip: string): boolean {
    return ip && Boolean(ip.match(IP_V6_REGEX));
}

export function isValidLink(url: string): boolean {
    try {
        const newUrl = new URL(url);
        return VALID_URL_PROTOCOLS.includes(newUrl.protocol) && newUrl.href === url;
    } catch {
        return false;
    }
}